/**
 * Cross-package constants. Re-exported via `@fellesen/api/constants` so the
 * web frontend can import the same values without re-declaring them.
 *
 * Add to this file only values that must be identical on both sides of the
 * wire (limits enforced by the Worker AND shown to the user in form
 * validation). Keep API-internal constants in their owning module.
 */

export const MAX_INVOICE_BYTES = 50 * 1024 * 1024;
export const MAX_INVOICE_MB = 50;
